if (!customElements.get('sku-drawer')) {
  customElements.define(
    'sku-drawer',
    class SKUDrawer extends HTMLElement {
      onVariantChangeUnsubscriber = undefined;
      lastFocusedElement = undefined;

      connectedCallback() {
        this.trigger = this.querySelector('[data-sku-drawer-trigger]');
        this.panel = this.querySelector('[data-sku-drawer-panel]');

        this.trigger?.addEventListener('click', this.open);
        this.querySelectorAll('[data-sku-drawer-close], [data-sku-drawer-add]').forEach((button) =>
          button.addEventListener('click', this.close)
        );
        this.panel?.addEventListener('close', this.handleClose);
        this.panel?.addEventListener('click', this.handleBackdropClick);

        this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
      }

      handleBackdropClick = (event) => {
        if (event.target === this.panel) this.close();
      };

      handleClose = () => {
        this.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
        this.lastFocusedElement?.focus();
      };

      handleVariantChange = ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;

        if (data.variant) {
          this.querySelectorAll('[data-sku-drawer-title], [data-sku-drawer-summary]').forEach((element) => {
            element.textContent = data.variant.title;
          });

          const variantIdInput = this.querySelector('[data-sku-drawer-variant-id]');
          if (variantIdInput) {
            variantIdInput.value = data.variant.id;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const priceElement = document.querySelector(`#price-${this.dataset.section}`);
        const drawerPrice = this.querySelector('[data-sku-drawer-price]');
        if (priceElement && drawerPrice) drawerPrice.innerHTML = priceElement.innerHTML;
      };

      open = () => {
        this.lastFocusedElement = document.activeElement;
        this.classList.add('is-open');
        this.trigger?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
        if (this.panel && !this.panel.open) this.panel.showModal();
      };

      close = () => {
        if (this.panel?.open) this.panel.close();
      };
    }
  );
}
